// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","control":"control-2UHM0","icon":"icon-dDoXB","root":"root-2XvDM","account":"account-XnZbO"};